export interface UploadedFile {
  id: string;
  fileName: string;
  fileSize: number;
  uploadedAt?: string;
}

export interface PendingFile {
  id: string;
  file: File;
}

export enum UploadErrorReason {
  TOO_LARGE = 'tooLarge',
  INVALID_TYPE = 'invalidType'
}
